import { GET_DELEGATE_ACCESS_MINE } from './query'

export const getDelegateAccessMine = async ({ client, shouldRefresh }) => {
  const { data } = await client.query({
    query: GET_DELEGATE_ACCESS_MINE,
    variables: { shouldRefresh },
  })
  return data.delegateAccess_getMine
}
